import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/work-calculator',
  component: () => import('../../routes/WorkCalculator.svelte'),
  card: {
    id: 'work-calculator',
    title: 'Work Calculator',
    description: 'Calculate work, force, or distance using W = F × d × cos(θ). Enter any three values to find the fourth.',
    icon: 'fitness_center',
    iconBgClass: 'bg-orange-50',
    iconTextClass: 'text-orange-600',
    href: '/work-calculator',
    category: 'Physics & Science',
  },
  seo: {
    title: 'Work Calculator – Calculate Work, Force & Distance | W = Fd cos(θ)',
    description:
      'Free work calculator to find work, force, or distance using W = F × d × cos(θ). Solves for any variable given the other three. Includes real-world examples.',
  },
};

export default meta;
